<template>
  <div class="px-2">
    <b-button
      :class="collapseVisible ? null : 'collapsed'"
      class="btn btn-secondary mb-3"
      :aria-expanded="collapseVisible ? 'true' : 'false'"
      aria-controls="filter-collapse"
      @click="collapseVisible = !collapseVisible"
    >
      {{ filterCollapseToggleText }}
    </b-button>

    <b-collapse v-model="collapseVisible" id="filter-collapse" class="row px-2">
      <USMultiselectInput
        wrapper-class="px-2 form-group col-12 d-flex flex-column col-xl-4"
        aria-label="empresa"
        label-text="Empresa"
        id="corporateGroupSelect"
        v-model="corporateGroupSelected"
        :options="corporateGroup.items"
        :loading="corporateGroup.loading"
        label="name"
        track-by="id"
        placeholder="Pesquisar Empresas"
        :show-label="false"
        @select="handleCorporateGroupToggle"
        @remove="handleCorporateGroupToggle(null)"
      />

      <USMultiselectInput
        aria-label="tipo-negocio"
        label-text="Tipo de negócio"
        id="businessTypeSelect"
        wrapper-class="px-2 form-group col-12 d-flex flex-column col-xl-4"
        placeholder="Pesquisar tipo de negócio"
        v-model="businessTypeSelected"
        :show-label="false"
        :options="businessType.items"
        :loading="businessType.loading"
        @select="handleBusinessTypeToggle"
        @remove="handleBusinessTypeToggle(null)"
        @search-change="handleBusinessTypeSearch"
        :disabled="!corporateGroupSelected"
      />

      <USMultiselectInput
        aria-label="unidade"
        label-text="Unidade"
        id="unitSelect"
        label="corporate_name"
        wrapper-class="px-2 form-group col-12 d-flex flex-column col-xl-4"
        track-by="id"
        :show-label="false"
        placeholder="Pesquisar Unidades"
        v-model="unitSelected"
        :options="unit.items"
        :loading="unit.loading"
        @select="handleUnitToggle"
        @remove="handleUnitToggle(null)"
        @search-change="handleUnitsSearch"
        :disabled="!corporateGroupSelected"
      />

      <USMultiselectInput
        aria-label="setor"
        label-text="Setor"
        id="sectorSelect"
        wrapper-class="px-2 form-group col-12 d-flex flex-column col-xl-4"
        :show-label="false"
        placeholder="Pesquisar Setores"
        v-model="sectorSelected"
        :options="sector.items"
        :loading="sector.loading"
        @select="handleSectorToggle"
        @remove="handleSectorToggle(null)"
        @search-change="handleSectorSearch"
        :disabled="!corporateGroupSelected || !unitSelected"
      />

      <USMultiselectInput
        aria-label="maquina"
        label-text="Máquina"
        id="machineSelect"
        label="name"
        wrapper-class="px-2 form-group col-12 d-flex flex-column col-xl-4"
        track-by="id"
        :show-label="false"
        placeholder="Pesquisar Máquinas"
        v-model="machineSelected"
        :options="machine.items"
        :loading="machine.loading"
        @search-change="handleMachinesSearch"
        :disabled="!corporateGroupSelected || !unitSelected"
      />
    </b-collapse>
  </div>
</template>

<script>
import USMultiselectInput from "@/components/ui/USMultiselectInput.vue";
import { types as companyReportTypes } from "@/store/modules/company-report";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "USRiskManagementFilters",
  components: {
    USMultiselectInput,
  },
  props: {
    startCollapsed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      collapseVisible: this.startCollapsed,
      abortControllers: {
        corporateGroup: {
          ref: null,
        },
        unit: {
          ref: null,
        },
        machine: {
          ref: null,
        },
        sector: {
          ref: null,
        },
        businessType: {
          ref: null,
        },
      },
      debounceTimers: {
        corporateGroup: {
          ref: null,
        },
        unit: {
          ref: null,
        },
        businessType: {
          ref: null,
        },
        sector: {
          ref: null,
        },
        machine: {
          ref: null,
        },
      },
      userRole: localStorage.getItem('auth.role') || null,
    };
  },

  beforeDestroy() {
    for (const key in this.abortControllers) {
      this.abortControllers[key].ref?.abort();
    }
    for (const key in this.debounceTimers) {
      clearTimeout(this.debounceTimers[key].ref);
    }
  },

  mounted() {
    this.fetchAllFilterData();
  },

  computed: {
    ...mapState(companyReportTypes.STORE_MODULE, {
      corporateGroup: companyReportTypes.CORPORATE_GROUP,
      unit: companyReportTypes.UNIT,
      businessType: companyReportTypes.BUSINESS_TYPE,
      sector: companyReportTypes.SECTOR,
      machine: companyReportTypes.MACHINE,
    }),
    filterCollapseToggleText() {
      return this.collapseVisible ? "Fechar Filtros" : "Abrir Filtros";
    },
    corporateGroupSelected: {
      get() {
        return this.corporateGroup.selected;
      },
      set(value) {
        this.setCorporateGroupSelected(value);
      },
    },
    unitSelected: {
      get() {
        return this.unit.selected;
      },
      set(value) {
        this.setUnitSelected(value);
      },
    },
    sectorSelected: {
      get() {
        return this.sector.selected;
      },
      set(value) {
        this.setSectorSelected(value);
      },
    },
    businessTypeSearchQuery: {
      get() {
        return this.businessType.searchQuery;
      },
      set(value) {
        this.setBusinessTypeSearchQuery(value);
      },
    },
    sectorSearchQuery: {
      get() {
        return this.sector.searchQuery;
      },
      set(value) {
        this.setSectorSearchQuery(value);
      },
    },
    businessTypeSelected: {
      get() {
        return this.businessType.selected;
      },
      set(value) {
        this.setBusinessTypeSelected(value);
      },
    },
    machineSelected: {
      get() {
        return this.machine.selected;
      },
      set(value) {
        this.setMachineSelected(value);
      },
    },
  },
  watch: {
    'corporateGroup.items'(newVal) {
      if (
        newVal?.length > 0 &&
        this.userRole === 'client' &&
        !this.corporateGroupSelected
      ) {
        // Seleciona a primeira empresa
        this.setCorporateGroupSelected(newVal[1]);
  
        // dispara lógica extra caso você precise
        this.handleCorporateGroupToggle(newVal[1]);
      }
    },
  },

  methods: {
    ...mapMutations(companyReportTypes.STORE_MODULE, {
      setCorporateGroupSelected:
        companyReportTypes.SET_CORPORATE_GROUP_SELECTED,
      setUnitSelected: companyReportTypes.SET_UNIT_SELECTED,
      setBusinessTypeSearchQuery:
        companyReportTypes.SET_BUSINESS_TYPE_SEARCH_QUERY,
      setSectorSearchQuery: companyReportTypes.SET_SECTOR_SEARCH_QUERY,
      setMachineSelected: companyReportTypes.SET_MACHINE_SELECTED,
      setCorporateGroupLoading: companyReportTypes.SET_CORPORATE_GROUP_LOADING,
      setUnitLoading: companyReportTypes.SET_UNIT_LOADING,
      setMachineLoading: companyReportTypes.SET_MACHINE_LOADING,
      setSectorLoading: companyReportTypes.SET_SECTOR_LOADING,
      setSectorSelected: companyReportTypes.SET_SECTOR_SELECTED,
      setBusinessTypeLoading: companyReportTypes.SET_BUSINESS_TYPE_LOADING,
      setBusinessTypeSelected: companyReportTypes.SET_BUSINESS_TYPE_SELECTED,
    }),

    ...mapActions(companyReportTypes.STORE_MODULE, {
      fetchCorporateGroups: companyReportTypes.FETCH_CORPORATE_GROUPS,
      fetchUnits: companyReportTypes.FETCH_UNITS,
      fetchMachines: companyReportTypes.FETCH_MACHINES,
      fetchSectors: companyReportTypes.FETCH_SECTORS,
      fetchBusinessTypes: companyReportTypes.FETCH_BUSINESS_TYPES,
    }),

    /**
     * @param {Object} options
     * @param {boolean} options.loading - The loading state.
     * @param {number|null} options.id - The ID.
     */
    loadingOrIdNull({ loading, id }) {
      return loading || id === null;
    },

    /**
     * @param {Object} options
     * @param {{ ref: AbortController|null }} options.abortController - An object holding an AbortController instance in its `ref` property.
     * @param {Function} options.callback - The function to execute with the AbortController signal.
     */
    executeWithAbort({ abortController, callback }) {
      abortController?.ref?.abort();
      abortController.ref = new AbortController();
      return callback({ signal: abortController.ref.signal });
    },

    /**
     * @param {Object} options
     * @param {{ ref: number|null }} options.timer - An object holding a timer ID in its `ref` property.
     * @param {Function} options.action - The function to debounce.
     * @param {number} [options.delay=500] - Delay in milliseconds before executing the action.
     */
    debounce({ timer, action, delay = 500 } = {}) {
      clearTimeout(timer.ref);
      timer.ref = setTimeout(() => {
        action();
        timer.ref = null;
      }, delay);
    },

    // handleCorporateGroupsSearch(searchQuery = "") {
    //   this.debounce({
    //     timer: this.debounceTimers.corporateGroup,
    //     action: () => this.loadCorporateGroups({ searchQuery }),
    //   });
    // },

    handleUnitsSearch(searchQuery = "") {
      this.debounce({
        timer: this.debounceTimers.unit,
        action: () => this.loadUnits({ searchQuery }),
      });
    },
    handleBusinessTypeSearch(searchQuery = "") {
      this.debounce({
        timer: this.debounceTimers.businessType,
        action: () => this.loadBusinessTypes({ searchQuery }),
      });
    },

    handleSectorSearch(searchQuery = "") {
      this.debounce({
        timer: this.debounceTimers.sector,
        action: () => this.loadSectors({ searchQuery }),
      });
    },

    fetchAllFilterData() {
      Promise.allSettled([
        this.loadCorporateGroups({ mounted: true }),
        // this.loadBusinessTypes({ mounted: true }),
        // this.loadUnits({ mounted: true }),
        // this.loadSectors({ mounted: true }),
        // this.loadMachines({ mounted: true }),
      ]);
    },

    handleMachinesSearch(searchQuery = "") {
      this.debounce({
        timer: this.debounceTimers.machine,
        action: () => this.loadMachines({ searchQuery }),
      });
    },

    resetMachineSelected() {
      this.setMachineSelected(null);
    },
    resetSectorSelected() {
      this.setSectorSelected(null);
      this.resetMachineSelected();
    },
    resetBusinessTypeSelected() {
      this.setBusinessTypeSelected(null);
      this.resetUnitSelected();
    },
    resetUnitSelected() {
      this.setUnitSelected(null);
      this.resetSectorSelected();
    },
    resetCorporateGroupSelected() {
      this.setCorporateGroupSelected(null);
      this.resetBusinessTypeSelected();
    },

    async handleCorporateGroupToggle() {
      this.resetUnitSelected();
      this.resetBusinessTypeSelected();
      
      if (!this.corporateGroupSelected) {
        return;
      }
      
      this.loadBusinessTypes();
      await this.loadUnits({ selectAllOnSuccess: true });
    },
    handleUnitToggle() {
      this.loadSectors();
    },
    handleBusinessTypeToggle() {
      this.loadUnits();
    },
    handleSectorToggle() {
      this.loadMachines();
    },

    async loadWithAbortControl({
      loadingSetter,
      abortController,
      fetchFn,
      params = {},
      onSuccess = () => {},
      onErrorMsg: errorMessage = "Erro ao buscar dados.",
    }) {
      loadingSetter(true);
      try {
        await this.executeWithAbort({
          abortController,
          callback: async ({ signal }) => await fetchFn({ ...params, signal }),
        });
        onSuccess();
      } catch (error) {
        this.$bvToast.toast(errorMessage, {
          title: "Erro na requisição",
          variant: "danger",
          autoHideDelay: 5000,
          toaster: "b-toaster-top-right",
        });
      } finally {
        loadingSetter(false);
      }
    },
    async loadCorporateGroups({
      page = 1,
      perPage = 10,
      searchQuery = "",
      mounted = false,
    } = {}) {
      if (this.corporateGroup.loading) {
        return;
      }
      if (this.userRole !== "client") {
        this.resetCorporateGroupSelected();
      }
      this.loadWithAbortControl({
        loadingSetter: this.setCorporateGroupLoading,
        abortController: this.abortControllers.corporateGroup,
        fetchFn: this.fetchCorporateGroups,
        params: { page, perPage, searchQuery, userRole: this.userRole},
        onSuccess: () => {
          if (!mounted) {
            this.loadBusinessTypes({ mounted: false });
          }
        },
        onErrorMsg: "Erro ao buscar grupos corporativos.",
      });
    },
    async loadUnits({
      page = 1,
      perPage = 10,
      searchQuery = "",
      reduced = false,
      mounted = false,
      selectAllOnSuccess = false,
    } = {}) {
      if (this.unit.loading) return;
      this.resetUnitSelected();
      const corporateGroupIds = this.corporateGroup.selected?.id
        ? [this.corporateGroup.selected.id]
        : this.corporateGroup.items.map((item) => item.id);

      this.loadWithAbortControl({
        loadingSetter: this.setUnitLoading,
        abortController: this.abortControllers.unit,
        fetchFn: this.fetchUnits,
        params: {
          page,
          perPage,
          searchQuery,
          reduced,
          corporateGroupIds,
          ...(this.businessTypeSelected 
          ? { businessTypes: [this.businessTypeSelected] } 
          : {}),
        },
        onSuccess: async () => {
          if (selectAllOnSuccess && this.corporateGroupSelected) {
            await this.$nextTick();
            this.setUnitSelected("");
            await this.$nextTick();
          }
          if (!mounted) {
            this.loadSectors({ mounted: false });
          }
        },
        onErrorMsg: "Erro ao buscar unidades.",
      });
    },
    async loadMachines({ page = 1, perPage = 10, searchQuery = "" } = {}) {
      if (this.machine.loading) return;
      const unitIds = this.unit.selected?.id
        ? [this.unit.selected.id]
        : this.unit.items.map((item) => item.id);
      this.resetMachineSelected();

      this.loadWithAbortControl({
        loadingSetter: this.setMachineLoading,
        abortController: this.abortControllers.machine,
        fetchFn: this.fetchMachines,
        params: {
          page,
          perPage,
          searchQuery,
          ...(this.sectorSelected
          ? { sectors: [this.sectorSelected] }
          : {}),
          unitIds,
        },
        onSuccess: () => {},
        onErrorMsg: "Erro ao buscar máquinas.",
      });
    },

    async loadSectors({
      unitIds = this.unit.selected?.id
        ? [this.unit.selected?.id]
        : this.unit.items.filter((item) => item !== "").map((item) => item.id),
      page = 1,
      perPage = 10,
      searchQuery = "",
      mounted = false,
    } = {}) {
      if (this.sector.loading) return;
      this.resetSectorSelected();

      this.loadWithAbortControl({
        loadingSetter: this.setSectorLoading,
        abortController: this.abortControllers.sector,
        fetchFn: this.fetchSectors,
        params: { unitIds, page, perPage, searchQuery },
        onSuccess: () => {
          if (!mounted) {
            this.loadMachines({ mounted: false });
          }
        },
        onErrorMsg: "Erro ao buscar setores.",
      });
    },

    async loadBusinessTypes({
      corporateGroupIds = this.corporateGroup.selected?.id
        ? [this.corporateGroup.selected?.id]
        : this.corporateGroup.items.map((item) => item.id),
      page = 1,
      perPage = 10,
      searchQuery = "",
      mounted = false,
    } = {}) {
      if (this.businessType.loading) return;
      this.resetBusinessTypeSelected();

      this.loadWithAbortControl({
        loadingSetter: this.setBusinessTypeLoading,
        abortController: this.abortControllers.businessType,
        fetchFn: this.fetchBusinessTypes,
        params: { corporateGroupIds, page, perPage, searchQuery },
        onSuccess: () => {
          if (!mounted) {
            this.loadUnits({ mounted: false });
          }
        },
        onErrorMsg: "Erro ao buscar tipos de negócio.",
      });
    },
  },
};
</script>
